import { PaymentMethodEnum, ProviderEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { StripeDirectPayForm } from './StripeDirectPayForm';

export const BlikPayForm = () => {
  const { paymentMethodsSettings } = useContext(CheckoutContext);
  const providerSettings = paymentMethodsSettings.find(
    (paymentMethod) => paymentMethod.paymentMethodName === PaymentMethodEnum.BLIK_CHECKOUT
  );

  if (providerSettings?.provider === ProviderEnum.STRIPE) {
    return <StripeDirectPayForm paymentMethod={PaymentMethodEnum.BLIK_CHECKOUT} />;
  }

  return null;
};
